import React from "react";
import { Link } from "react-router-dom";
import { FaSignOutAlt, FaBars } from "react-icons/fa";
import logo2 from "../../images/logo/logo2.png";
import { Helmet } from "react-helmet";

export default function HeaderPainel({
  usuario,
  menuOpen,
  setMenuOpen,
  handleLogout,
  loadingLogout,
}) {

  const sanitizeUrl = (url) => {
    if (!url || typeof url !== "string") return null;

    let u = url.trim();

    u = u.replace(/\\\\/g, "/").replace(/\\/g, "/");
    u = u.replace(/^V\//i, "");
    u = u.replace(/https:\/+/g, "https://");

    if (/^[A-Z]:\//i.test(u)) {
      const file = u.split("/").pop();
      return `https://megasisteminformatica.com.br/API/usuario/logo-usuario/${file}`;
    }

    if (!u.startsWith("http")) {
      const file = u.split("/").pop();
      return `https://megasisteminformatica.com.br/API/usuario/logo-usuario/${file}`;
    }

    return u;
  };

  const avatarFinal = sanitizeUrl(usuario?.avatar) || "https://via.placeholder.com/150";
  const nomeFinal = usuario?.nome || "Usuário";
  const funcaoFinal = usuario?.funcao || "";

  return (
    <>
      {/* Fonte Comfortaa */}
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
        <link
          href="https://fonts.googleapis.com/css2?family=Comfortaa:wght@300..700&display=swap"
          rel="stylesheet"
        />
      </Helmet>

      <header className="bg-black py-3 px-4 md:px-8 flex justify-between items-center shadow-xl sticky top-0 z-50 border-b border-gray-800 font-comfortaa">

        {/* LOGO E TÍTULO */}
        <div className="flex items-center gap-4">
          <Link
            to="/painel"
            className="relative transform hover:scale-105 transition-all duration-300"
          >
            <img
              src={logo2}
              alt="Logo do Sistema"
              className="h-14 md:h-16 object-contain"
            />
          </Link>

          <div className="hidden sm:block">
            <h1 className="text-white text-lg md:text-2xl font-semibold">
              Control Service
            </h1>
            <p className="text-gray-300 text-xs md:text-sm opacity-80">
              Gestão Inteligente de Chamados e Agendamentos
            </p>
          </div>
        </div>

        {/* MENU MOBILE */}
        <div className="md:hidden">
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="text-white text-2xl p-2 rounded-lg hover:bg-white/10"
          >
            <FaBars />
          </button>
        </div>

        {/* USUÁRIO */}
        {usuario && (
          <div className="hidden md:flex items-center gap-6">

            {/* AVATAR + NOME + FUNÇÃO */}
            <div className="flex items-center gap-3 pr-3 border-r border-gray-700">

              {/* AVATAR */}
              <div className="relative w-12 h-12">
                <img
                  src={avatarFinal}
                  alt="Avatar"
                  className="w-12 h-12 rounded-full object-cover shadow-lg border border-gray-600"
                />

                {/* STATUS ONLINE */}
                <span className="absolute -bottom-0.5 -right-0.5 w-3.5 h-3.5 rounded-full bg-green-500 border-[2px] border-black"></span>
              </div>

              {/* NOME + FUNÇÃO */}
              <div className="flex flex-col leading-tight">
                <span className="text-white text-sm font-comfortaa">
                  {nomeFinal}
                </span>

                <span className="text-gray-400 text-xs font-comfortaa mt-0.5">
                  {funcaoFinal}
                </span>
              </div>
            </div>

            {/* BOTÃO SAIR */}
            <button
              onClick={handleLogout}
              disabled={loadingLogout}
              className="bg-[#f95000] text-white px-5 py-2 rounded-md flex items-center gap-2 shadow-lg disabled:opacity-50"
            >
              {loadingLogout ? (
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              ) : (
                <FaSignOutAlt />
              )}
              <span className="hidden lg:inline">Sair</span>
            </button>
          </div>
        )}
      </header>
    </>
  );
}
